App.SettingsIntegrationsSettingsController = Em.Controller.extend
  iframeSrc: 'https://smartomato.ru/board2'
